module.exports = __webpack_public_path__ + "img/sand-rock-big-03.198e5ea9.png";